import { MENU_HOME, HOME_PATH } from '@constant'

export default {
  key: MENU_HOME,
  id: '',
  title: '首页',
  icon: 'icon-shouye',
  link: HOME_PATH
}
